import { PaymentOrderInfo } from './invoice.queries'
import { OldPaymentOrderInfo } from 'features/Orders/PublicInvoice/components/Payment'
import { BillingAddressDictionary } from 'features/Orders/types'

// TODO: remove once we use the atlas query in Payments as this are conversions
// made purely to follow the same common model we have for OR & payments
export const getPaymentsOrderData = (
  order: PaymentOrderInfo,
): OldPaymentOrderInfo => ({
  ...order,
  taxAmount: order?.tax?.amountString
    ? Number(order?.tax?.amountString)
    : (order.tax?.amount ?? 0),
  shippingPrice: order.shipping?.price,
  shippingEmail: order.shipping?.address?.email ?? '',
  currencyCode: order.priceType?.currency?.code,
  lineItems: {
    totalUnits: 0,
    totalPrice: 0,
    totalRetailPrice: 0,
    discountedPrice: 732, // every value inside lineItems is mocked as we wait for this field in backend
  },
  brandName: order.brand.name,
  billingAddress: [
    order.billing?.address?.firstAddress ?? '',
    order.billing?.address?.secondAddress ?? '',
  ],
  retailer: order.retailerProfile,
})

export const getBillingAddressDictionary = (
  order: PaymentOrderInfo,
): BillingAddressDictionary => ({
  name: order.billing.address.name ?? '',
  email: order?.shipping?.address?.email
    ? order?.shipping?.address?.email
    : order?.retailerProfile?.email
      ? order?.retailerProfile?.email
      : '',
  street: `${order.billing.address.firstAddress ?? ''} ${
    order.billing.address.secondAddress ?? ''
  }`.trim(),
  city: order.billing.address.city ?? '',
  country: order.billing.address.country ?? '',
  state: order.billing.address.state ?? '',
  zip: order.billing.address.zip ?? '',
})
